<template>
  <Flex class="show-msg" v-show="isShow">
    <div class="inner-flex">
      <p>{{msg1}}</p>
      <p>{{msg2}}</p>
    </div>
  </Flex>
</template>

<script>
import Flex from '@/components/Flex'
import { ref, watch } from 'vue'

export default {
  name: 'ShowMsg',
  props: { msg: [String, Array] },
  components: { Flex },
  setup (p) {
    const msg1 = ref('')
    const msg2 = ref('')
    const isShow = ref(false)

    const showMsg = msg => {
      isShow.value = true
      msg2.value = ''
      typeof msg === 'object'
        ? msg.forEach((i, idx) => { if (idx === 0) { msg1.value = i } else { msg2.value = i } })
        : msg1.value = msg
      setTimeout(_ => { isShow.value = false }, 3000)
    }

    watch(_ => p.msg, showMsg)

    return {
      msg1,
      msg2,
      isShow
    }
  }
}
</script>

<style lang="scss" scoped>
.show-msg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  color: white;
  background: rgba(0, 0, 0, .5);
}
.inner-flex {
  display: inline-block;
  text-align: center;
  background: rgba(0, 0, 0, .5);
  padding: 10px;
  border-radius: 10px;
}
p {
  font-size: 18px;
  line-height: 1.5;
}
</style>
